import {
  Box,
  List,
  Paper,
  Popper,
  ListItemText,
  ListItemButton,
  CircularProgress,
} from '@mui/material';

import { profileType } from 'src/pages/chat/utils/get-nav-item';

import { Iconify } from 'src/components/iconify';

type Props = {
  open: boolean;
  anchorEl: HTMLElement | null;
  data: any[];
  isLoading: boolean;
  type: string;
  onItemSelect: (item: any) => void;
};

export function DropdownList({ open, anchorEl, data, isLoading, type, onItemSelect }: Props) {
  if (!open) return null;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      modifiers={[
        {
          name: 'offset',
          options: { offset: [0, 8] }, // 8px vertical offset
        },
      ]}
      style={{
        width: anchorEl ? anchorEl.clientWidth : undefined,
        zIndex: 1300,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: '100%',
          maxHeight: 260,
          overflowY: 'auto',
        }}
      >
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : data.length === 0 ? (
          <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>No records found</Box>
        ) : (
          <List dense disablePadding>
            {data.map((item) => {
              const isChannel = 'channelType' in item;
              const selectedProfileType = isChannel
                ? profileType.find((profile) => profile.type === item.channelType)
                : null;

              return (
                <ListItemButton key={item.id} onClick={() => onItemSelect(item)}>
                  <Box
                    sx={{
                      gap: 2,
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    {isChannel && selectedProfileType?.icon && type === 'Channel' && (
                      <Iconify
                        icon={selectedProfileType.icon}
                        sx={{
                          width: 25,
                          height: 25,
                          mr: 1,
                          flexShrink: 0,
                        }}
                      />
                    )}

                    <ListItemText
                      primary={
                        item?.displayName ??
                        item?.name ??
                        (item?.firstName || item?.lastName
                          ? `${item.firstName ?? ''} ${item.lastName ?? ''}`.trim()
                          : null) ??
                        item?.email ??
                        item?.channelName ??
                        '-'
                      }
                      secondary={item?.email || item?.phone || item?.channelConfig || ''}
                    />
                  </Box>
                </ListItemButton>
              );
            })}
          </List>
        )}
      </Paper>
    </Popper>
  );
}
